import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './table__head.scss';

const TableHead = (props) => {
    const { children, mix } = props;

    return <div className={cx('table__head', mix)}>{children}</div>;
};

TableHead.propTypes = {
    children: PropTypes.node,
    mix: PropTypes.string,
};

export default TableHead;
